// extracted by mini-css-extract-plugin
export default {"p-3":"Loader_p-3__2kjZX","border":"Loader_border__RHIQ3","rounded":"Loader_rounded__jCBYy","offering-preview":"Loader_offering-preview__YF5Wr","root":"Loader_root__jRgkk"};